import Swal from "sweetalert2";
import { EventBus } from '@/eventBus';
import config from "../../../../config";
import gudangController from "../../../controllers/gudangController/controller";
export default {
    name: 'SimpleTable',
    data(){
        return{
            company: '',
            gudangList: [],
            currentPage: 1,
            pageSize: 10,
            totalGudang: 0,
            apiUrl: config.AWS_URL + 'gambar/dc/',
            totalPages: 0,
            searchQuery: '',
            dropdownOpen: false,
            gambarName: 'Pilih Gambar',
            gambarUrl: '',
            gudang: {
                name : '',
                dc : '',
                link_maps : '',
                total_pallet_positions : '',
                total_employees : '',
                language: '',
                status: '',
                created_by: '',
                created_by_name: '',
                created_on: '',
            },
            selectedGudang: {
                updated_by: '',
                updated_by_name: '',
            }
        }
    },
    computed: {
        filteredGudang() {
            const search = this.searchQuery.toLowerCase();
            return this.gudangList.filter(gudang => {
                return gudang.name.toLowerCase().includes(search)
            })
        },
        pages() {
            return Math.ceil(this.totalGudang / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
            
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
            if (start === 1) {
                end = Math.min(3, this.pages);
            } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
            }
            }
            
            const pages = [];
            for (let i = start; i <= end; i++) {
            pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        }
    },
    mounted() {
        
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
        if (this.company === '1') {
            this.$router.replace('/');
        }
    },
    methods: {
        user() {
            const user = JSON.parse(localStorage.getItem('user'));
            const { mst_employee_id: id, mst_employee_name: name } = user;
            this.gudang.created_by = id;
            this.selectedGudang.updated_by = id;
            this.gudang.created_by_name = name;
            this.selectedGudang.updated_by_name = name;
            return user;
        },
        showModal(type, id) {
            this.user();
            const gudang = this.gudangList.find(gudang => gudang.id === id);
            if (gudang) {
                this.gudang = gudang;
                this.selectedGudang = gudang;
                const modal = document.getElementById(type === 'edit' ? 'editGudang' : 'detailGudang');
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                    modal.classList.add('show');
                });
                document.body.classList.add('modal-open');
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                requestAnimationFrame(() => {
                    backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
            const modalIds = ['tambahGudang', 'editGudang', 'detailGudang'];
            modalIds.forEach(id => {
                const modal = document.getElementById(id);
                if (modal && modal.classList.contains('show')) {
                    modal.classList.remove('show');
                    setTimeout(() => {
                        modal.style.display = 'none';
                    }, 300);
                }
            });
            // Hapus backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
                backdrop.classList.remove('show');
                setTimeout(() => {
                    if (backdrop.parentNode) {
                        backdrop.parentNode.removeChild(backdrop);
                    }
                }, 300);
            });
            // Hapus kelas atau atribut yang mengunci scroll pada body
            const body = document.body;
            body.classList.remove('modal-open');
            body.style.overflow = ''; // Menghapus properti overflow jika ada
            this.fetchGudang();
            this.resetForm();
        },
        resetForm() {
            this.gambarName = 'Pilih Gambar';
            this.gambarUrl = '';
            this.gudang.name = '';
            this.gudang.link_maps = '';
            this.gudang.total_pallet_positions = '';
            this.gudang.total_employees = '';
            this.gudang.status = '';
            this.gudang.language = '';
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchGudang();
            }
        },
        
        async handleFileUpload(event) {
            try{
                const file = event.target.files[0];
                if (file) {
                    this.gambarName = file.name;
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.gambarUrl = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
                if (!file) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Silahkan pilih file',
                        timer: 1500
                    })
                    return;
                }

                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
                if (!allowedTypes.includes(file.type)) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Format file tidak sesuai',
                        timer: 1500
                    })
                    this.gambarName = 'Pilih Gambar';
                    this.gambarUrl = '';
                    return;
                }
                const allowedSize = 1 * 1024 * 1024; // 1 MB
                if (file.size > allowedSize) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Ukuran file tidak boleh lebih dari 1 MB',
                        timer: 1500
                    })
                    this.gambarName = 'Pilih Gambar';
                    this.gambarUrl = '';
                    return;
                }

                this.gudang.dc = file;
            } catch (error) {
                console.error('Error uploading file:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan saat mengunggah file',
                    timer: 1500
                })
            }
        },
        async fetchGudang() {
            try{
                const company_id = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await gudangController.fetchGudang(query, this.currentPage, this.pageSize, company_id);
                this.gudangList = response.data;
                this.totalGudang = response.total;
                console.log(this.gudangList);
            } catch (error){
                console.error('Error fetching gudang:', error);
            }
        },
        async totalAllGudang() {
            try {
                const company_id  = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await gudangController.totalAllGudang(query, company_id);
                this.totalGudang = response.data;
            } catch (error) {
                console.error('Error fetching gudang:', error);
                throw error;
            }
        },
        async addGudang() {
            try{
                Swal.fire({
                    title: 'Loading.....',
                    text: 'Please wait while the gudang is being added',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        Swal.showLoading();
                    }
                });

                const formData = new FormData();
                const now = new Date();
                this.gudang.created_on = now.toISOString().slice(0, 19).replace('T', ' ');
                formData.append('name', this.gudang.name);
                formData.append('link_maps', this.gudang.link_maps);
                formData.append('total_pallet_positions', this.gudang.total_pallet_positions);
                formData.append('total_employees', this.gudang.total_employees);
                formData.append('status', this.gudang.status);
                formData.append('language', this.gudang.language);
                formData.append('created_by', this.gudang.created_by);
                formData.append('created_by_name', this.gudang.created_by_name);
                formData.append('created_on', this.gudang.created_on);
                formData.append('company', this.company);
                formData.append('dc', this.gudang.dc);

                const response = await gudangController.addGudang(formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                Swal.close();

                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Gudang berhasil ditambahkan',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.closeModal();
                    this.getGudang();
                    this.resetForm();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan gudang',
                        text: 'Terjadi kesalahan saat menambahkan gudang',
                        timer: 1500
                    });
                }
            } catch (error){
                console.error('Error adding gudang:', error);
            }
        },
        async updateGudang() {
            const user = this.user();
            try{
                const id = this.gudang.id;
                const name = this.gudang.name;
                const link_maps = this.gudang.link_maps;
                const total_pallet_positions = this.gudang.total_pallet_positions;
                const total_employees = this.gudang.total_employees;
                const status = this.gudang.status;
                const updated_by = user.mst_employee_id;
                const updated_by_name = user.mst_employee_name;
                const updated_on = new Date().toISOString().slice(0, 19).replace('T', ' ');
                if (!id || !name || !link_maps || !total_pallet_positions || !total_employees || !status || !updated_by || !updated_by_name || !updated_on) {
                    throw new Error('Isi semua field!!');
                }  
                const update = {
                    id: id,
                    name : name,
                    link_maps : link_maps,
                    pallet : total_pallet_positions,
                    employees : total_employees,
                    is_active: status,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    updated_on: updated_on,
                }
                const response = await gudangController.updateGudang(update);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Gudang berhasil diperbaharui',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.closeModal();
                    this.resetForm();
                    this.fetchGudang();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal memperbaharui data',
                        timer: 1500
                    })
                }
            } catch (error){
                console.error('Error updating gudang:', error);
                throw error;
            }
        },
        async deleteGudang(id, dc) {
            try{
                const confirmed = await Swal.fire({
                    title: 'Are you sure?',
                    text: 'You won\'t be able to revert this!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then ((result) => {
                    if (result.isConfirmed) {
                        return true;
                    }
                    return false;
                });
                if (!confirmed) {
                    return;
                }
                const response = await gudangController.deleteGudang(id, dc);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Gudang berhasil dihapus',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.fetchGudang();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menghapus data',
                        timer: 1500
                    })
                }
            } catch (error){
                console.error('Error deleting gudang:', error);
                throw error;
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        },
    },
    beforeDestroy() {
        EventBus.$off("companyChanged", this.onCompanyChange);
    },
    watch: {
        searchQuery: {
            handler: 'fetchGudang', // Nama metode yang dipanggil setiap searchQuery berubah
        },
        company: {
            handler: 'fetchGudang', // Nama metode yang dipanggil setiap searchQuery berubah
        }
    }
}